<template>
    <div class="cover-box" ref="contentPageDom">
<!--        <div class="cover-img">-->
<!--            <img :src="publicPath + 'static/images/ShopopeeComCover.jpg'"  alt=""/>-->
<!--        </div>-->

        <div>
            <el-row :gutter="48">
                <el-col
                    :span="8"
                    v-for="(value, index) in cardList"
                    :key="index + '' + Math.random()"
                    class="record-box"
                >
                    <div>
                        <div class="card-img">
                            <img
                                :src="getCardImgSrc(value)"
                                alt=""
                                v-if="null != value.addinfo8 && '' !== value.addinfo8"
                            />

                            <img
                                :src="getCardImgSrc(value)"
                                alt=""
                                v-if="null == value.addinfo8 || '' === value.addinfo8"
                                style="height: 64.7%; top: 17.65%;"
                            />
                        </div>

                        <ul class="card-info">
                            <li class="company-name">
                                {{value.workcompany}}
                            </li>

                            <li>
                                {{value.workcompany2}}
                            </li>

                            <li>
                                {{value.name}}
                            </li>

                            <li>
                                {{value.name2}}
                            </li>

                            <li>
                                {{value.email}}
                            </li>

                            <li>
                                {{value.telephone}}
                            </li>
                        </ul>
                    </div>
                </el-col>
            </el-row>
        </div>

        <div class="pageFooter">
            <hr>
            <span>{{pageIndex}}</span>
        </div>
    </div>
</template>

<script setup>

import {ref, onMounted} from "vue";
import myUtil from "@/util/util";
import html2canvas from "html2canvas";

const props = defineProps(["cardList", "pageIndex"])
const emits = defineEmits(["print-complete"])

const contentPageDom = ref(null)

function getCardImgSrc(obj){
    let src = myUtil.generateCardImgRelativeUrl(obj.cardinfo)

    if (myUtil.isNotEmpty(obj.addinfo8)){
        src = obj.addinfo8
    }

    return src
}

function printImg(){
    html2canvas(contentPageDom.value,{
        useCORS: true
    })
    .then(canvas => { //scala默认1 控制字体线条粗细
        const imgBase64 = canvas.toDataURL("image/jpeg")

        emits("print-complete", imgBase64, props.pageIndex)

    });
}

onMounted(() => {
    setTimeout(() => {
        printImg()
    }, 500)
})

</script>

<style scoped>
.cover-box {
    width: 2480px;
    height: 3504px;
    position: relative;
    text-align: center;
    box-sizing: border-box;
    padding: 50px 80px;
}

.card-img {
    position: relative;
    width: 100%;
    padding-top: 100%;
    border: 4px #E4E7ED solid;
    box-sizing: border-box;
    border-radius: 30px;
    overflow: hidden;
}

.card-img img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    //object-fit: contain;
}

.cover-box ul {
    list-style: none;
    padding-left: 0;
}

.card-info {
    font-size: 32px;
    color: #606266;
}

.card-info .company-name {
    color: #303133;
    font-weight: 600;
}

.card-info li {
    margin-bottom: 0.5em;
}

.record-box {
    margin-bottom: 48px;
}

.pageFooter {
    position: absolute;
    bottom: 8px;
    left: 0;
    //border-top: 4px #E4E7ED solid;
    font-size: 32px;
    font-weight: 600;
    width: 100%;
    color: #606266;
    padding-left: 80px;
    padding-right: 80px;
    box-sizing: border-box;
}

</style>